import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { getAppVariable } from '@white-label-helper/get-app-variable';
import type { Item, Total } from '@white-label-types/parking-checkout';
import {
  add,
  format,
  parseISO,
  DATE_TIME_FORMATS,
} from '@white-label-helper/date-utilities';

interface PartnerizeTrackingProps {
  items: Item[];
  orderTotals: Total,
  conversionRef: string,
  clickRef?: string;
  isLoggedIn?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'partnerize-tracking',
  props: {
    items: null,
    orderTotals: null,
    conversionRef: null,
    clickRef: null,
    isLoggedIn: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  items: Item[];
  orderTotals: Total,
  conversionRef: string,
  clickRef?: string;
  isLoggedIn?: boolean;
};



const isActive = computed<boolean>(() => {
  return getAppVariable('partnerize.is_active');
});

const srcUrl = computed<string>(() => {
  let url = 'https://prf.hn/conversion/';

  // generar info
  url += `campaign:${getAppVariable('partnerize.partner_id')}/`;
  url += `country:${getAppVariable('poi.country.code')}/`;
  url += `currency:${getAppVariable('default_currency')}/`;
  url += `customertype:${props.isLoggedIn ? 'existing' : 'new'}/`;
  url += `conversionref:${props.conversionRef}/`;

  if (props.clickRef) {
    url += `clickref:${props.clickRef}/`;
  }

  const discountCode = props.items.find((item) => item.discount?.code && item.product_code === 'parking')?.discount?.code;

  if (discountCode) {
    url += `voucher:${discountCode}/`;
  }

  props.items.forEach((item) => {
    const entryDate = typeof item.order_criteria[item.product_code]?.date1  ? parseISO(item.order_criteria[item.product_code]?.date1) : null;
    const exitDate = item.order_criteria[item.product_code]?.date2 ? parseISO(item.order_criteria[item.product_code]?.date2) : null;

    let entryDateFormatted;
    let exitDateFormatted;
    const bookingDate = format(parseISO(item.created_at.datetime), DATE_TIME_FORMATS.day_month_year_in_numbers);

    if (entryDate) {
      entryDateFormatted = format(entryDate, DATE_TIME_FORMATS.day_month_year_in_numbers);
    }
    if (exitDate) {
      exitDateFormatted = format(exitDate, DATE_TIME_FORMATS.day_month_year_in_numbers);
    }

    let days;
    let stayDuration;

    if (entryDate && exitDate) {
      const addOneDay = add(exitDate, { days: 1 });
      days = (+addOneDay - +entryDate) / 864e5;
      stayDuration = Math.round(days) || 1;
    }

    const terminalName = item.order_criteria[item.product_code]?.terminal
      ? item.poi.terminals.find((terminal) => terminal.id === item.order_criteria[item.product_code]?.terminal)?.name
      : null;

    const str = appendItemInfo({
      arrival_date: entryDateFormatted,
      departure_date: entryDateFormatted,
      exit_date: exitDateFormatted,
      booking_date: bookingDate,
      category: item.inventory_item.product_name,
      value: item.totals.subtotal,
      discount: item.totals.discount,
      airport_name: item.poi.name,
      airport_code: item.poi.code,
      terminal: terminalName,
      outbound_flight: item.user.outbound_flight,
      gross_value: props.orderTotals.total,
      original_price: props.orderTotals.total,
      stay_duration: stayDuration,
      sales_revenue: props.orderTotals.cavu_commission || 0,
      inventory_id_number: item.order_criteria[item.product_code]?.inventory_id,
    });

    url += str;
  });

  return url;
});

function appendItemInfo(item: { [key: string]: string | Number | null | undefined }): string {
  let string = '[';

  // Append every existing item object
  Object.keys(item).forEach(key => {
    if (item[key] !== null && item[key] !== undefined) {
      string += `${(key)}:${item[key]}/`
    }
  });

  // Replace last char `/` with closing `]`
  string = string.substring(0, string.length - 1);
  string += ']';

  return string;
};

return { __sfc: true,props, isActive, srcUrl, appendItemInfo }
}

})